import omit from 'lodash/omit';
import { SearchBar } from 'app/components/Song';
import React from 'react';
import { BaseSongListQueryParams } from 'types/song';

interface AudioSearchBarProps {
  songAudioListValidation?: BaseSongListQueryParams | undefined;
  onSearch: (search: string) => void;
}

export const AudioSearchBar = ({
  songAudioListValidation,
  onSearch,
}: AudioSearchBarProps) => {
  return (
    <SearchBar
      containerProps={{
        maxWidth: 480,
        width: '100%',
        margin: 'auto',
        mb: 6,
      }}
      textFieldProps={{
        'data-testid': 'audio-selection-list-search',
        ...omit(songAudioListValidation?.search, ['type', 'description']),
      }}
      onSearch={onSearch}
      placeholder="Search Songs"
    />
  );
};
